import { AfterContentInit, Directive, Inject, Input, OnDestroy } from "@angular/core";
import { forEach as _forEach } from "lodash";
import { Subscription } from "rxjs";
import { ICommonFilterActionCreator } from "../../redux/actions.interface";
import { GenericActions } from "../../redux/generic-actions";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { MULTISELECT_FILTER_STATE_PROP } from "./state-props";

@Directive({
    selector: "[common-multiselect-filter-action-creators]",
    exportAs: "CommonMultiselectFilterActionsDirective",
})
export class CommonMultiselectFilterActionsDirective implements AfterContentInit, OnDestroy {
    @Input("multiselectFilterStateProp") public stateProp: string;
    @Input() public listActions: ICommonFilterActionCreator<boolean>;
    @Input() public fieldToFilter: string;
    public state$: Subscription;
    public filters: any[] = [];

    constructor(private ngRedux: ImmutableRedux<any>,
                @Inject(MULTISELECT_FILTER_STATE_PROP) public rootProp) {
    }

    public ngAfterContentInit() {
        this.state$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state) => {
            this.filters = state.filters;
            if (this.filters) {
                const filterValues = state.filters.filter((f) => !!f.state).map((f) => f.value);
                this.listActions.filter(this.fieldToFilter, filterValues);
            }
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public toggleFilter(index, event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.ngRedux.dispatchFactory(GenericActions.TOGGLE_SELECT, this.rootProp, this.stateProp, index);
    }

    public clearAllFilters() {
        _forEach(this.filters, (f, i) => {
            if (f.state) {
                this.ngRedux.dispatchFactory(GenericActions.TOGGLE_SELECT, this.rootProp, this.stateProp, i);
            }
        });
    }
}
